
export default {
    name: 'historique-traitement',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


